import React from "react";
import PrivateLesson from "./privateLesson/PrivateLesson";
import GroupLesson from "./groupLesson/GroupLesson";
import OnlineLesson from "./OnlineLesson";

export default function LessSwitcher({ path }) {
  switch (path) {
    case "/private":
      return <PrivateLesson />;
    case "/group":
      return <GroupLesson />;
    case "/online":
      return <OnlineLesson />;
    default:
      return <PrivateLesson />;
  }
}
